module.exports = (__webpack_public_path__ || '') + "static/images/favicon-32x32-adc7bacd8e56317287a7407684b9a8d0.png";